"use client";
import { IBlocks, IUserData } from "@/types";
import React from "react";
import {
    Carousel,
    CarouselContent,
    CarouselItem,
    CarouselNext,
    CarouselPrevious,
} from "@/components/ui/carousel";
import Autoplay from "embla-carousel-autoplay";
import type { BlockUpdateFunction } from "./utils/blocks-map";
import AdminPopover from "./utils/AdminPopover";
import BlockClickHandler from "./utils/click";
import { BORDER_RADIUS_OPTIONS } from "./utils/block-style-classes";
import { cn } from "@/lib/utils";
interface Props {
    edit?: boolean;
    account: IUserData;
    theme: IUserData["chosen_theme"];
    block: IBlocks;
    update?: BlockUpdateFunction;
}
export default function BlockCarousel({
    edit,
    theme,
    account,
    block,
    update,
}: Props) {
    const [blockUpdate, setBlockUpdate] = React.useState(block);
    let plugins = [];
    if (blockUpdate.options.autoplay) {
        plugins.push(Autoplay({ delay: blockUpdate.options.autoplay_delay }));
    }
    const borderRadius =
        BORDER_RADIUS_OPTIONS[theme.profile.design.corner_radius]?.remValue;
    return (
        <AdminPopover
            edit={edit}
            className={block.show ? "" : "opacity-30"}
            title={"Carousel"}
            block={block}
            update={update}
            setBlockUpdate={setBlockUpdate}
        >
            <div
                key={block.id}
                className={cn(
                    `relative flex w-full flex-row flex-wrap gap-2 p-2`,
                    "block-" + block.id
                )}
                style={{ borderRadius: borderRadius }}
                id="Carousel"
            >
                <Carousel
                    className="w-full"
                    opts={{
                        align: "start",
                        loop: true,
                    }}
                    plugins={plugins}
                >
                    <CarouselContent className="">
                        {blockUpdate.options?.images?.map(
                            (image: any, index: number) => {
                                return (
                                    <CarouselItem
                                        key={index}
                                        className="h-auto"
                                    >
                                        <div className="h-96 w-full p-1">
                                            <div className="flex h-full items-center justify-center">
                                                {image.link ? (
                                                    <a
                                                        href={image.link}
                                                        target="_blank"
                                                        className="relative inline-block h-full w-full"
                                                        onClick={(e) => {
                                                            BlockClickHandler(
                                                                account,
                                                                e,
                                                                block
                                                            );
                                                        }}
                                                        onAuxClick={(e) => {
                                                            BlockClickHandler(
                                                                account,
                                                                e,
                                                                block
                                                            );
                                                        }}
                                                    >
                                                        <div className="relative h-full w-full">
                                                            <img
                                                                src={image.url}
                                                                className={`absolute left-0 top-0 h-full w-full object-contain`}
                                                                style={{
                                                                    borderRadius:
                                                                        borderRadius,
                                                                }}
                                                                alt={
                                                                    "Image " +
                                                                    index.toString()
                                                                }
                                                                id="block-icon"
                                                            />
                                                        </div>
                                                    </a>
                                                ) : (
                                                    <div className="relative h-full w-full">
                                                        <img
                                                            src={image.url}
                                                            className={`absolute left-0 top-0 h-full w-full object-contain`}
                                                            style={{
                                                                borderRadius:
                                                                    borderRadius,
                                                            }}
                                                            alt={
                                                                "Image " +
                                                                index.toString()
                                                            }
                                                            id="block-icon"
                                                        />
                                                    </div>
                                                )}
                                                {image.caption && (
                                                    <p
                                                        className={`absolute bottom-0 w-fit max-w-full truncate text-nowrap px-3`}
                                                        style={{
                                                            background:
                                                                account.theme
                                                                    .button,
                                                            color: account.theme
                                                                .text_col_button,
                                                            borderRadius:
                                                                borderRadius,
                                                        }}
                                                    >
                                                        {image.caption}
                                                    </p>
                                                )}
                                            </div>
                                        </div>
                                    </CarouselItem>
                                );
                            }
                        )}
                    </CarouselContent>
                    <CarouselPrevious
                        className="bg-user-primary-color text-user-primary-text-color hover:scale-105"
                        style={{
                            borderColor: "transparent",
                            border: 0,
                        }}
                    />
                    <CarouselNext
                        className="bg-user-primary-color text-user-primary-text-color hover:scale-105"
                        style={{
                            borderColor: "transparent",
                            border: 0,
                        }}
                    />
                </Carousel>
            </div>
        </AdminPopover>
    );
}
